/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EAssetDateRangeSelectionMode {
    Previous7Days = 0,
    LastWeek = 1,
    Custom = 2
}
